export const LoadInformationFieldNames = {
  Commodity: 'commodity',
  FloridaLoadDescription: 'floridaLoadDescription',
  FloridaLoadIdentity: 'floridaLoadIdentity',
  FloridaPermitType: 'floridaPermitType',
  LoadDescription: 'loadDescription',
  LoadDisposition: 'loadDisposition',
  LoadEndToEndCount: 'loadEndToEndCount',
  LoadHeight: 'loadHeight',
  LoadIndustryType: 'loadIndustryType',
  LoadIsNewlyManufactured: 'loadIsNewlyManufactured',
  LoadIsSingleItem: 'loadIsSingleItem',
  LoadLength: 'loadLength',
  LoadLoadingMethod: 'loadLoadingMethod',
  LoadMake: 'loadMake',
  LoadModel: 'loadModel',
  LoadOwnerAddress: 'loadOwnerAddress',
  LoadOwnerName: 'loadOwnerName',
  LoadQuantity: 'loadQuantity',
  LoadSealedContainerChassisNumber: 'loadSealedContainerChassisNumber',
  LoadSealedContainerNumber: 'loadSealedContainerNumber',
  LoadSerialNumber: 'loadSerialNumber',
  LoadSideBySideCount: 'loadSideBySideCount',
  LoadStackCount: 'loadStackCount',
  LoadWeight: 'loadWeight',
  LoadWidth: 'loadWidth',
  LoadYear: 'loadYear',
} as const;

export type LoadInformationFields = {
  [LoadInformationFieldNames.Commodity]?: string;
  [LoadInformationFieldNames.FloridaLoadDescription]?: string;
  [LoadInformationFieldNames.FloridaLoadIdentity]?: string;
  [LoadInformationFieldNames.FloridaPermitType]?: string;
  [LoadInformationFieldNames.LoadDescription]?: string;
  [LoadInformationFieldNames.LoadDisposition]?: string[];
  [LoadInformationFieldNames.LoadEndToEndCount]?: number;
  [LoadInformationFieldNames.LoadHeight]?: number | string;
  [LoadInformationFieldNames.LoadIndustryType]?: string;
  [LoadInformationFieldNames.LoadIsNewlyManufactured]?: boolean;
  [LoadInformationFieldNames.LoadIsSingleItem]?: boolean;
  [LoadInformationFieldNames.LoadLength]?: number | string;
  [LoadInformationFieldNames.LoadLoadingMethod]?: string;
  [LoadInformationFieldNames.LoadMake]?: string;
  [LoadInformationFieldNames.LoadModel]?: string;
  [LoadInformationFieldNames.LoadOwnerAddress]?: string;
  [LoadInformationFieldNames.LoadOwnerName]?: string;
  [LoadInformationFieldNames.LoadQuantity]?: number;
  [LoadInformationFieldNames.LoadSealedContainerChassisNumber]?: string;
  [LoadInformationFieldNames.LoadSealedContainerNumber]?: string;
  [LoadInformationFieldNames.LoadSerialNumber]?: string;
  [LoadInformationFieldNames.LoadSideBySideCount]?: number;
  [LoadInformationFieldNames.LoadStackCount]?: number;
  [LoadInformationFieldNames.LoadWeight]?: number;
  [LoadInformationFieldNames.LoadWidth]?: number | string;
  [LoadInformationFieldNames.LoadYear]?: number;
};

export const LoadFields: string[] = Object.values(LoadInformationFieldNames);
